import AddContractorsAndVendors from "../../Operations/AddContractorsAndVendors";
import AddPurchaseOrders from "../../Operations/Vendor/PurchaseOrders/AddPurchaseOrder";
import PurchaseOrderDetailsPage from "../../Operations/Vendor/PurchaseOrders/PurchaseOrderDetailsPage";
import { PurchaseOrdersListComp } from "../../Operations/Vendor/PurchaseOrders/PurchaseOrders";
import GrnTable from "../../Operations/Vendor/GRN/GrnTable";
import AddGrn from "../../Operations/Vendor/GRN/AddGrn";
import { VendorsListComp } from "../../Operations/Vendor/Vendors/Vendors";
import PurchaseInvoiceTable from "../../Operations/Procurement/Invoices/PurchaseInvoice/PurchaseInvoiceTable";
import PurchaseInvoiceForm from "../../Operations/Procurement/Invoices/PurchaseInvoice/PurchaseInvoiceForm";
import MaterialRequisitions from "../../Operations/Stocks/MaterialRequisitions/MaterialRequisitions";
import QuotesTable from "../../Operations/Procurement/Quotations/Quotes/QuotesTable";
import AddQuote from "../../Operations/Procurement/Quotations/Quotes/AddQuote";
import QuotesComparisonTable from "../../Operations/Procurement/Quotations/Comparison/QuotesComparisonTable";
import AddQuotesComparison from "../../Operations/Procurement/Quotations/Comparison/AddQuotesComparison";
import ProcurementDashboard from "../../Operations/Procurement/ProcurementDashboard";
import PORegisterFulfillmentReport from "../../Operations/Procurement/Reports/PORegisterFulfillmentReport";
import PRToPOConversionPipelineReport from "../../Operations/Procurement/Reports/PRToPOConversionPipelineReport";
import ThreeWayMatchingAuditReport from "../../Operations/Procurement/Reports/ThreeWayMatchingAuditReport";
import VendorPaymentAgingLedgerReport from "../../Operations/Procurement/Reports/VendorPaymentAgingLedgerReport";
import ProcurementSpendAnalysisReport from "../../Operations/Procurement/Reports/ProcurementSpendAnalysisReport";
import VendorPerformanceScorecardReport from "../../Operations/Procurement/Reports/VendorPerformanceScorecardReport";

export const procurementRoutes = [
  {
    path: "/procurement",
    component: <ProcurementDashboard />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/procurement/dashboard",
    component: <ProcurementDashboard />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/procurement/purchase-requisition",
    component: <MaterialRequisitions />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/procurement/quotations",
    component: <QuotesTable />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/procurement/quotations/quotes",
    component: <QuotesTable />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/procurement/quotations/quotes/add",
    component: <AddQuote />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/procurement/quotations/quotes/edit/:id",
    component: <AddQuote />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/procurement/quotations/comparison",
    component: <QuotesComparisonTable />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/procurement/quotations/comparison/add",
    component: <AddQuotesComparison />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/procurement/quotations/comparison/edit/:id",
    component: <AddQuotesComparison />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/procurement/vendors",
    component: <VendorsListComp />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/procurement/vendors/vendors/add",
    component: <AddContractorsAndVendors isContractor={false} />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/procurement/purchase-order",
    component: <PurchaseOrdersListComp />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/procurement/GRN",
    component: <GrnTable />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/procurement/vendors/GRN/add",
    component: <AddGrn />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/procurement/vendors/purchase-order/details/:id",
    component: <PurchaseOrderDetailsPage />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/procurement/vendors/purchase-order/add",
    component: <AddPurchaseOrders />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/procurement/purchase-invoice",
    component: <PurchaseInvoiceTable />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/procurement/purchase-invoice/add",
    component: <PurchaseInvoiceForm />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/procurement/reports",
    component: <PORegisterFulfillmentReport />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/procurement/reports/po-fulfillment",
    component: <PORegisterFulfillmentReport />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/procurement/reports/pr-conversion",
    component: <PRToPOConversionPipelineReport />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/procurement/reports/three-way-match",
    component: <ThreeWayMatchingAuditReport />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/procurement/reports/vendor-aging",
    component: <VendorPaymentAgingLedgerReport />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/procurement/reports/procurement-spend",
    component: <ProcurementSpendAnalysisReport />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/procurement/reports/vendor-performance",
    component: <VendorPerformanceScorecardReport />,
    rolename: "Store Dashboard_View",
  },
];
